import { z } from 'zod';
import { OpenapiCategoriesAndGamesStaffGetCategoriesAndGamesResponse200Type } from 'src/domains/casino/api/generated/categories-and-games/openapi_categories_and_games_staff_get_categories_and_games';
import { ParamsType } from 'src/domains/casino/api/generated/categories-and-games/openapi_categories_and_games_staff_add_new_game';
import { OpenapiBannersStaffGetBannersResponse200Type } from 'src/domains/casino/api/generated/banners/openapi_banners_staff_get_banners';
import { ApiGetCampaignsResponse200Type } from 'src/api_openapi/v2/bonus-engine/apiGetCampaigns';
import { ApiGetBonusCreationsResponse200Type } from 'src/api_openapi/v2/bonus-engine/apiGetBonusCreations';
import { CasinoStoreCollectionType, CasinoStoreProviderType } from 'src/api_openapi/v2/casino-store/schemas';

// main casino domain types

export type CollectionType = CasinoStoreCollectionType;

export type KindType = 'Slots' | 'LiveCasino' | 'VirtualSports';
export type ProviderType = CasinoStoreProviderType;

// config types
type CasinoProviderType = Extract<
    CasinoStoreProviderType,
    'sg-digital' | 'pragmatic' | 'evolution' | 'leap' | 'relax' | 'blueprint'
>;
type LiveCasinoProviderType = Extract<CasinoStoreProviderType, 'ezugi' | 'pragmatic' | 'evolution'>;
type VirtualsProviderType = Extract<CasinoStoreProviderType, 'leap' | 'pragmatic'>;

export type ConfigProvidersType = {
    casino: Array<CasinoProviderType>;
    'live-casino': Array<LiveCasinoProviderType>;
    virtuals: Array<VirtualsProviderType>;
};

// constant names

export const PRAGMATIC_NAME = 'Pragmatic';
export const SG_DIGITAL_NAME = 'SG Digital';
export const EZUGI_NAME = 'Ezugi';
export const EVOLUTION_NAME = 'Evolution';
export const LEAP_NAME = 'Leap';
export const RELAX_NAME = 'Relax';
export const BLUEPRINT_NAME = 'Blueprint';

export const FILTER_ALL = 'All';
export const DEFAULT_CATEGORY_NAME = 'Category Name';

// game model types

export interface ProviderGameType {
    launchId: string;
    name: string;
    provider: CasinoStoreProviderType;
    providerName: string;
    collection: CollectionType | undefined;
    studio: {
        id: string;
        name: string;
    };
    imageUrl: string;
    demo: boolean;
    // ID If Casino store enabled
    id?: number;
}

export interface GameStudioType {
    id: string;
    name: string;
}

// CategoriesAndGames
export type CategoriesAndGamesResponseType = OpenapiCategoriesAndGamesStaffGetCategoriesAndGamesResponse200Type;
export type CategoryType = CategoriesAndGamesResponseType['categories'][number];
export type GameType = CategoriesAndGamesResponseType['games'][number];
export type InsertGameType = ParamsType['requestBody']['game_details'];

export type CasinoBannersResponseType = OpenapiBannersStaffGetBannersResponse200Type;
export type CasinoBannerType = CasinoBannersResponseType['banners'][number];

// Bonus Engine
export type ApiGetSingleCampaignType = ApiGetCampaignsResponse200Type[number];

export type CampaignRouteType =
    | {
          type: 'EDIT';
          view: CampaignViewType;
          campaignId: string;
      }
    | {
          type: 'NEW';
          view: CampaignViewType;
          cloneId: string | null;
      };

export const CampaignViewSchema = z.union([
    z.literal('general-details'),
    z.literal('promo-code'),
    z.literal('action-conditions'),
    z.literal('reward-conditions'),
    z.literal('player-management'),
]);

export type CampaignViewType = z.infer<typeof CampaignViewSchema>;

export type ApiGetBonusCreationsType = ApiGetBonusCreationsResponse200Type[number];

export const BonusCreationViewSchema = z.union([z.literal('general-details'), z.literal('reward-conditions')]);

export type BonusCreationViewType = z.infer<typeof BonusCreationViewSchema>;

export type BonusCreationRouteType =
    | {
          type: 'EDIT';
          view: BonusCreationViewType;
          bonusCreationId: string;
      }
    | {
          type: 'NEW';
          view: BonusCreationViewType;
          cloneId: string | null;
      };
